<template>
    <div class="login-container">
        <div class="login-form-content" v-show="type === 1">
            <div class="logo">
                <img src="../assets/images/Logo.png" alt="监控平台" />
            </div>
            <div class="form-group">
                <el-input style="margin-bottom: 5px;" v-model="loginForm.username" placeholder="账号"></el-input>
                <el-input v-model="loginForm.password" type="password" placeholder="密码" @keyup.enter.native="login">
                </el-input>
            </div>
            <div class="type-change">
                <el-button type="text" @click="changeType">微信登录</el-button>
            </div>
            <el-button class="login-btn" type="primary" @click="login">登 录</el-button>
        </div>
        <div class="login-form-content" v-show="type === 2">
            <div class="qrcode-container">
                <iframe :src="wxLoginQrcode" style="height: 400px"></iframe>
                <el-button type="text" @click="changeType">账号登录</el-button>
            </div>
        </div>
    </div>
</template>

<script>
import Core from 'core';
import { mapMutations } from 'vuex';
import * as types from '../store/mutation-types';

export default {
    data() {
        return {
            type: 1,
            loginForm: {
                username: '',
                password: ''
            },
            wxLoginQrcode: ''
        };
    },
    mounted() {
        if (this.$route.query.token) {
            Core.Data.setToken(this.$route.query.token);
            Core.Api.User.detail().then((res) => {
                this.setUser(res.user);
            }).finally(() => {
                this.$router.replace({ path: '/alarm/list' });
            });
        }
    },
    methods: {
        ...mapMutations({
            setUser: types.SET_USER
        }),
        async changeType() {
            this.type = this.type === 1 ? 2 : 1;
            if (this.type === 2) {
                const res = await this.getWxLoginQrcode();
                this.wxLoginQrcode = res.url;
            }
        },
        getWxLoginQrcode() {
            return Core.Api.User.wxLoginQrcode(1);
        },
        login() {
            if (!this.loginForm.username.trim()) {
                this.$message({
                    type: 'warning',
                    message: '请输入账号!'
                });
                return;
            }
            if (!this.loginForm.password.trim()) {
                this.$message({
                    type: 'warning',
                    message: '请输入密码!'
                });
                return;
            }
            Core.Api.User.login(this.loginForm.username, this.loginForm.password).then((res) => {
                Core.Data.setToken(res.token);
                this.setUser(res.user);
                this.$router.replace({
                    path: '/alarm/list'
                });
            });
        }
    }
};
</script>

<style scoped lang="scss">
.login-container {
    width: 100vw;
    height: 100vh;
    background: #323943;
    box-sizing: border-box;
    padding-top: 200px;
    .login-form-content {
        width: 300px;
        margin: 0 auto;
        text-align: center;
        .form-group {
            margin: 60px 0 0 0;
        }
        .login-btn {
            width: 80%;
        }
        .type-change {
            width: 300px;
            margin: 0 auto;
            text-align: right;
            margin-bottom: 20px;
        }
        .qrcode-container {
            background: #fff;
        }
    }
}
</style>
